module.exports = __webpack_public_path__ + "static/media/promo.6934952d.svg";